
import BaseApi from "../BaseApi";

export default class EmployeeCoursesService extends BaseApi {


    constructor(){
        super();
    }
 
    /**
     * index
     */
    async index(filter)
    {
        return this.http.get(`${this.baseUrl}/app/courses${filter}`)
        .catch(this.handleErrorResponse);
    }

    async getCourse(id)
    {
        return this.http.get(`${this.baseUrl}/app/courses/${id}`)
        .catch(this.handleErrorResponse);
    }
    async getCourseProgress(id)
    {
        return this.http.get(`${this.baseUrl}/app/courses/${id}/progress`)
        .catch(this.handleErrorResponse);
    }


    async saveProgress(id, data)
    {
        return this.http.post(`${this.baseUrl}/app/lessons/${id}/progress`, data)
        .catch(this.handleErrorResponse);
    }

    async getLesson(id)
    {
        return this.http.get(`${this.baseUrl}/app/lessons/${id}`)
        .catch(this.handleErrorResponse);
    }

}